// extracted by mini-css-extract-plugin
export default {"container":"ModifierComposante_container__DUL0t","btn_stylo":"ModifierComposante_btn_stylo__t4gLE"};